<template>
  <v-dialog
    v-bind="$attrs"
    v-on="$listeners"
    :fullscreen="$vuetify.breakpoint.xs"
    :max-width="450"
  >
    <slot></slot>
  </v-dialog>
</template>

<script>
export default {
  name: "BaseDialog"
};
</script>

<style lang="scss" scoped></style>
